import React from "react";
import BookingHead from "../components/Booking/Head";
import BookingSidebar from "../components/Booking/Sidebar";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const BookingPage = () => {
  const screen = useSelector((state) => state.userReducer.screen);

  return (
    <div className="bookingPage">
      {screen.desktop ? (
        <>
          <div className="main">
            <BookingHead />
            <div className="body">
              <Outlet />
            </div>
          </div>
          <BookingSidebar />
        </>
      ) : (
        <BookingSidebar />
      )}
    </div>
  );
};

export default BookingPage;
